import React, { useState, useEffect } from "react";
import PageWrapperForm from "../../components/PageWrapperForm";
import { fetchWrapper } from "utils/apiFetch";

const NewsSectionPage = () => {
  const [smsPassword, setSmsPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null); // { text, type }

  // GET current sms_password on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const formdata = new FormData();
        formdata.append("action", "GET");

        const result = await fetchWrapper("https://pro.mokshiq.in/company_action", {
          method: "POST",
          body: formdata,
        });

        if (result?.data?.length > 0) {
          setSmsPassword(result.data[0].sms_password || "");
        }
      } catch (err) {
        setMessage({ text: "Failed to load SMS password.", type: "danger" });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // UPDATE sms_password
  const handleUpdate = async () => {
    setSaving(true);
    setMessage(null);
    try {
      const formdata = new FormData();
      formdata.append("action", "UPDATE_SMS_PASSWORD");
      formdata.append("sms_password", smsPassword);

      const result = await fetchWrapper("https://pro.mokshiq.in/company_action", {
        method: "POST",
        body: formdata,
      });

      if (result.status) {
        setMessage({ text: result.data, type: "success" });
      } else {
        setMessage({ text: result.data, type: "danger" });
      }
    } catch (err) {
      setMessage({ text: "Something went wrong.", type: "danger" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <main>
      <div className="container-fluid">
        {/* Breadcrumb */}
        <div className="row m-1">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="main-title">News Section</h4>
              <ul className="app-line-breadcrumbs mb-3">
                <li>
                  <a className="f-s-14 f-w-500" href="#">
                    <i className="iconoir-home-alt f-s-16"></i>
                  </a>
                </li>
                <li className="active">
                  <a className="f-s-14 f-w-500" href="#">
                    News Section
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="row advance-table-section">
          <div className="col-12">
            <div className="card shadow-sm border-0 rounded-4">
              <div className="card-body p-4">
                {message && (
                  <div className={`alert alert-${message.type}`} role="alert">
                    {message.text}
                  </div>
                )}

                {loading ? (
                  <p>Loading...</p>
                ) : (
                  <>
                    <div
                      className="d-flex align-items-center mb-4 p-3 rounded-3"
                      style={{ backgroundColor: "#f4f2ff" }}
                    >
                      <div
                        className="d-flex justify-content-center align-items-center rounded-3 bg-white"
                        style={{
                          width: "48px",
                          height: "48px",
                          color: "#7e57c2",
                        }}
                      >
                        <i className="ph-duotone ph-newspaper f-s-24"></i>
                      </div>
                      <div className="ms-3">
                        <h5
                          className="mb-0 fw-bold"
                          style={{ color: "#1a1a1a" }}
                        >
                          Update News Section
                        </h5>
                        <small className="text-muted">
                          Edit and update the news section content
                        </small>
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="form-label fw-bold" style={{ color: "#2d3748" }}>
                        New Section <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control py-2"
                        value={smsPassword}
                        onChange={(e) => setSmsPassword(e.target.value)}
                        placeholder="Enter News Section Content"
                        style={{ borderRadius: "8px" }}
                      />
                    </div>
                    
                    <button
                      className="btn btn-primary px-4 py-2 mt-2 d-inline-flex align-items-center"
                      onClick={handleUpdate}
                      disabled={saving}
                      style={{
                        backgroundColor: "#7e57c2",
                        borderColor: "#7e57c2",
                        borderRadius: "8px",
                        fontWeight: "500",
                        width: "fit-content",
                      }}
                    >
                      <i className="iconoir-send-diagonal me-2 f-s-18"></i>
                      {saving ? "Updating..." : "Update News"}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NewsSectionPage;